import type { Bout } from '../rules/bout';

/**
 * Keeps the player's block matching the held key or finger: raised as soon as he is free to raise it, lowered when let
 * go. A press held through a punch or a dodge blocks the moment that ends.
 */
export class BlockHold {
  sync(bout: Bout, held: boolean): void {
    const player = bout.player;
    if (held && player.state === 'ready') bout.submit('player', { hand: 'left', action: 'blockStart' });
    else if (!held && player.state === 'blocking') bout.submit('player', { hand: 'left', action: 'blockEnd' });
  }
}
